import type { FeatureFlagCheck } from '../api/featureFlags';

/** Enabled by default when the flag is missing or not yet loaded (e.g. landing, logged out). */
const DEFAULT_ENABLED_FEATURE_FLAGS = new Set(['pricing_subscription']);

export const defaultFeatureFlagEnabled = (flagName: string): boolean =>
  DEFAULT_ENABLED_FEATURE_FLAGS.has(flagName);

export const defaultFeatureFlagCheck = (
  flagName: string
): FeatureFlagCheck => ({
  flag_name: flagName,
  is_enabled: defaultFeatureFlagEnabled(flagName),
  reason: 'not_found',
});
